
/* injects from baggage-loader */

import React, { Component } from 'react';
import _ from 'lodash';
import { getSwarmSubscriptionRequestCashdesk } from '../../../helpers/terminalRequests/cashdesk';
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { PrintLotteryTickets } from '../../../actions/terminal';
import PropTypes from 'prop-types';
import Helpers from '../../../helpers/helperFunctions';
class CashdeskSubscriptionComponent extends Component {

    constructor (props) {
        super(props);
        this.state = {
            iframeUrl: null
        };

    }
    UNSAFE_componentWillReceiveProps (nextProps, nextState) {
        var terminalId = this.state.terminalId || undefined;
        let cashdeskNextkObj;
        if (this.props.swarmData && nextProps.swarmData.cashdesk && terminalId) {
            cashdeskNextkObj = nextProps.swarmData.cashdesk[terminalId];
        }
        let cashdeskkObj;
        if (this.props.swarmData && this.props.swarmData.cashdesk && terminalId) {
            cashdeskkObj = this.props.swarmData.cashdesk[terminalId];
        }
        if (cashdeskNextkObj && cashdeskNextkObj.casino_bet) {
            if (!cashdeskkObj || !cashdeskkObj.casino_bet || cashdeskkObj.casino_bet.Transaction_id !== cashdeskNextkObj.casino_bet.Transaction_id) {
                let addInfo = JSON.parse(cashdeskNextkObj.casino_bet.additional_info);

                let possWin = addInfo.PossibleWin;
                if (!cashdeskNextkObj.casino_bet.Amount || (cashdeskNextkObj.casino_bet.Amount !== addInfo.BetAmount)) { // in cases when Amount is absent or wrong(not good case, should be resolved)
                    cashdeskNextkObj.casino_bet.Amount = addInfo.BetAmount;
                }
                let betAmount = cashdeskNextkObj.casino_bet.Amount;

                if (possWin && this.props.tax && _.isNumber(this.props.tax.taxPercent) && (this.props.tax.taxIntegrationType === 0 || this.props.tax.taxIntegrationType === 2)) {
                    const tax = (() => {
                        switch (this.props.tax.taxType) {
                            case 1:
                                return Helpers.calculateTaxForReturnedAndProfit(this.props.tax.taxPercent, possWin - betAmount, this.props.tax.taxRange || null);
                            case 2:
                                return Helpers.calculateTaxForReturnedAndProfit(this.props.tax.taxPercent, possWin, this.props.tax.taxRange || null);
                        }
                    })();
                    cashdeskNextkObj.casino_bet.possible_tax_amount = tax;
                }
                this.props.dispatch(PrintLotteryTickets(JSON.stringify(cashdeskNextkObj.casino_bet), false));
            }
        }
    }
    componentDidMount () {
        this.setState({
            terminalId: sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).tid
        });
    }

    render () {
        return <span />;
    }
}

CashdeskSubscriptionComponent.propTypes = {
    params: PropTypes.objectOf(PropTypes.any),
    user: PropTypes.objectOf(PropTypes.any).isRequired,
    swarmData: PropTypes.object,
    cashdesk: PropTypes.object,
    tax: PropTypes.object
};

const mapStateToProps = () => {
    return createSelector(
        [
            state => state.cashdesk,
            state => state.user,
            state => (state.swarmData.data && state.swarmData.data.cashdesk),
            state => state.swarmConfigData.partner && (() => {
                let tax = {};
                tax.taxType = state.swarmConfigData.partner.tax_type;
                tax.taxPercent = state.swarmConfigData.partner.tax_percent;
                tax.taxIntegrationType = state.swarmConfigData.partner.tax_integration_type;
                tax.taxRange = state.swarmConfigData.partner.tax_amount_ranges;
                return tax;
            })()
        ],
        (cashdesk, user, swarmData, tax) => {
            return {
                cashdesk,
                user,
                swarmData,
                tax
            };
        }
    );
};
export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: CashdeskSubscriptionComponent,
        ComponentWillMount: function () {
            this.swarmSubscriptionRequest = getSwarmSubscriptionRequestCashdesk(this.props.authData); //todo move this from lottery component
            this.swarmDataKey = 'cashdesk';
            this.keepDataAfterUnsubscribe = true;
        }
    }
));
